import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled } from "@mui/material/styles";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { makeStyles } from "@mui/styles";
import {
    Box,
    Button,
    FormControl,
    Grid,
    TextField,
    Select,
    Tooltip,
    Typography,
} from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import { useState, useRef } from "react";
import FuseAnimate from "@fuse/core/FuseAnimate";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon";
import addIcon from '../../../../assets/add-training.svg';
import { borderTop } from "@mui/system";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useEffect } from "react";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import AddAttendees from "./AddAttendees";

const moment = extendMoment(originalMoment);

const useStyles = makeStyles((theme) => ({
    addButton: {
        position: "absolute",
        right: 30,
        top: 135,
        zIndex: 99,
    },
}))

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& input": {
        padding: "10px 14px",
        height: '0.4375em',
    },
    ".muiltr-rboi0c-MuiInputBase-root-MuiOutlinedInput-root": {
        lineHeight: 0.7,
        minHeight: '25px',
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "& input": {
        height: "0.4375em",
    },
    "&.MuiInputBase-root": {
        lineHeight: 1.5,
        minHeight: '27px',
    }
}
))

const AddTrainingForm = (props) => {
    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.trainingRequests}`;
    const classes = useStyles(props);
    const { selectedTab, selectedYear, selectedDateRange, datesArray } = props;
    const [selectedCustomerCode, setSelectedCustomerCode] = useState('Customer Code');
    const viewCustomerCode = ['Customer Code', 'UAE30001', 'KUWAIT30003', 'MALIDIVES30009'];
    const [selectedTrainingMode, setSelectedTrainingMode] = useState('Training Mode');
    const viewTrainingMode = ['Training Mode', 'Online', 'Physical'];
    const [selectedShowroomLocation, setSelectedShowroomLocation] = useState("showroom location");
    const viewShowroomLocation = ['showroom location', 'Dubai'];
    const [selectedTrainingDay, setSelectedTrainingDay] = useState('--/--/----');
    const viewTrainingDay = ['23/11/2023'];
    const [selectedTrainingCourse, setSelectedTrainingCourse] = useState('Training Course');
    const viewTrainingCourse = ['Training Course', 'Product', 'Software', 'Operation', 'Specific'];
    const [selectedTrainingTopic, setSelectedTrainingTopic] = useState('Training Topic');
    const [viewTrainingTopic, setViewTrainingTopic] = useState(['Training Topic']);

    const [showAttendeeList, setShowAttendeeList] = useState(false);

    const alertRef = useRef();

    const trainingTopics = [{ 'Training Course': ['Training Topic'] },
    { 'Product': ['NK', 'NE', 'EK', 'NEO', 'Nolte-spa'] },
    { 'Software': ['Winner'] },
    { 'Operation': ['Sales Order Processing', 'Installation', 'Logistics'] },
    { 'specific': ['Intro-Nolte Group', 'Innovation', 'Project', 'Retail', 'Design', 'Sales Path', 'Professional Development', 'Personal Development'] }
    ];
    const [selectedInstructor, setSelectedInstructor] = useState('Instructor');
    const viewInstructor = ['Instructor', 'Salam', 'Chona Mahilum', 'Sujith', 'Arun', 'Remin', 'Mohit'];

    const [selectedCountryList, setSelectedCountryList] = useState('country list');
    const viewCountryList = ['coutnry list', 'Dubai'];
    const [selectedAttendeesList, setSelectedAttendeesList] = useState('attendees list');
    const viewAttendeesList = ['attendees list', 'Remin'];

    const [trainingInformation, setTrainingInformation] = useState({});

    // My code
    const [choosenInformation, setChoosenInformation] = useState({})

    const [choosenValues, setChoosenValues] = useState(datesArray.reduce((acc, date) => {
        acc[date] = {
            trainingCourse: '',
            trainingTopic: '',
            instructor: ''
        };
        return acc;
    }, {}));

    const [openSnackBar, setOpenSnackBar] = useState(false);

    const handleTrainingInformation = (field, value, dates) => {
        setTrainingInformation((prevValues) => {
            const dateRange = selectedDateRange;

            if (dates) {
                // Check if the date exists in the date range
                if (prevValues[selectedYear] && prevValues[selectedYear][dateRange] && prevValues[selectedYear][dateRange][dates]) {
                    // If the date exists, update the existing date object
                    let newInformation = { ...prevValues[selectedYear] };
                    let modifyNew = { ...newInformation[dateRange][dates], [field]: value };

                    return {
                        ...prevValues,
                        [selectedYear]: {
                            ...newInformation,
                            [dateRange]: {
                                ...newInformation[dateRange],
                                [dates]: modifyNew
                            }
                        }
                    };
                } else {
                    // If the date doesn't exist, create a new date object
                    let newInformation = { ...prevValues[selectedYear] };
                    let modifyNew = { ...newInformation[dateRange], [field]: value };
                    return {
                        ...prevValues,
                        [selectedYear]: {
                            ...newInformation,
                            [dateRange]: {
                                ...modifyNew,
                                [dates]: { [field]: value }
                            }
                        }
                    };
                }
            } else {
                // If no specific date is provided, update the general date range information
                let newInformation = { ...prevValues[selectedYear] };
                let modifyNew = { ...newInformation[dateRange], [field]: value };
                return {
                    ...prevValues,
                    [selectedYear]: {
                        ...newInformation,
                        [dateRange]: modifyNew
                    }
                };
            }
        });
    };

    // const handleTrainingInformation = (field, value, index) => {
    //     setChoosenInformation(prevValues => {
    //         const dateRange = selectedDateRange;
    //         let newInformation = { ...prevValues[dateRange], [field]: value };
    //         return { ...prevValues, [dateRange]: newInformation }
    //     }
    //     )
    // }

    const handleSelectChange = (index, field, value) => {
        setChoosenValues(prevValues => {
            const dateValue = datesArray[index];
            let newValues = { ...prevValues[dateValue], [field]: value };
            if (field === 'trainingCourse') {
                // const topicValuestoDisplay = trainingTopics.find(item => value in item);
                // const topicArray = topicValuestoDisplay ? topicValuestoDisplay[value] : [];
                // setViewTrainingTopic(topicArray);
                const topicValues = trainingTopics.find((item) => value in item)
                const initialTopic = topicValues ? topicValues[value][0] : '';
                newValues = { ...newValues, trainingTopic: initialTopic };
            }

            // setViewTrainingTopic(topicArray);
            // }
            return { ...prevValues, [dateValue]: newValues };
        });
    };

    const dateRangesEx = () => {
        sessionStorage.setItem("dateRangesFromSession", JSON.stringify(trainingInformation[selectedYear]))
    }

    useEffect(() => {
        if (Object.entries(trainingInformation).length > 0) {
            dateRangesEx()
        }
    }, [trainingInformation]);

    const onSaveDraft = async () => {
        try {
            const list = await OAuthService.getPostList(url, trainingInformation);
            setRowData(list.data);
        } catch (error) {
            setError(error.message);
        }
        const jsonString = JSON.stringify(trainingInformation);
        localStorage.setItem("plannedEvent", jsonString);
        setOpenSnackBar(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
    };

    const handleAddAttendee = () => {
        setShowAttendeeList(true);
    }

    const handleCloseAttendee = () => {
        setShowAttendeeList(false)
    }

    return (
        <>
            {/* <Box sx={{ flexGrow: 1 }}>
                <div className="flex"> */}
            {/* <FormControl className="flex flex-row flex-nowrap"> */}
            <h5>Training Information</h5>
            <Grid container spacing={2} className="mt-4">
                <Grid item md={6} lg={6}>
                    <div className="mr-16">
                        <StyledTextField type="text" variant="outlined" fullWidth name="company" value={selectedDateRange} aria-readonly />
                    </div>
                </Grid>
                <Grid item md={6} lg={6}>
                    <div className="mr-16">
                        <StyledSelect
                            className="w-full rounded-8 h-2.5 overflow-hidden"
                            value={choosenInformation[selectedDateRange]?.trainingMode}
                            name="trainingMode"
                            onChange={(e) => { setSelectedTrainingMode(e.target.value); handleTrainingInformation('trainingMode', e.target.value) }}
                            variant="outlined"
                        >
                            {viewTrainingMode
                                .map((val, index) => (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        className="m-8 mt-0 rounded-lg"
                                    >
                                        {val}
                                    </MenuItem>
                                ))}
                        </StyledSelect>
                    </div>
                </Grid>
                <Grid item md={6} lg={6}>
                    <div className="mr-16">
                        <StyledSelect
                            className="w-full rounded-8 h-2.5 overflow-hidden"
                            value={choosenInformation[selectedDateRange]?.custCode}
                            name="customerCode"
                            onChange={(e) => { setSelectedCustomerCode(e.target.value); handleTrainingInformation('custCode', e.target.value) }}
                            variant="outlined"
                        >
                            {viewCustomerCode
                                .map((val, index) => (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        className="m-8 mt-0 rounded-lg"
                                    >
                                        {val}
                                    </MenuItem>
                                ))}
                        </StyledSelect>
                    </div>
                </Grid>
                <Grid item md={6} lg={6}>
                    <div className="mr-16">
                        <StyledSelect
                            className="w-full rounded-8 h-2.5 overflow-hidden"
                            value={choosenInformation[selectedDateRange]?.showRoomLocation}
                            name="showroomLocation"
                            onChange={(e) => { setSelectedShowroomLocation(e.target.value); handleTrainingInformation('showRoomLocation', e.target.value) }}
                            variant="outlined"
                        >
                            {viewShowroomLocation
                                .map((val, index) => (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        className="m-8 mt-0 rounded-lg"
                                    >
                                        {val}
                                    </MenuItem>
                                ))}
                        </StyledSelect>
                    </div>
                </Grid>
                {/* {selectedTab === "forecast" &&
                    <>
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledSelect
                                    className="w-full rounded-8 h-2.5 overflow-hidden"
                                    value={selectedCountryList}
                                    name="countryList"
                                    onChange={(e) => { setSelectedCountryList(e.target.value); handleCountryListChange(e.target.value) }}
                                    variant="outlined"
                                >
                                    {viewCountryList
                                        .map((val, index) => (
                                            <MenuItem
                                                key={val}
                                                value={val}
                                                className="m-8 mt-0 rounded-lg"
                                            >
                                                {val}
                                            </MenuItem>
                                        ))}
                                </StyledSelect>
                            </div>
                        </Grid>
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledSelect
                                    className="w-full rounded-8 h-2.5 overflow-hidden"
                                    value={selectedAttendeesList}
                                    name="attendeesList"
                                    onChange={(e) => { setSelectedAttendeesList(e.target.value); handleAttendeesListChange(e.target.value) }}
                                    variant="outlined"
                                >
                                    {viewAttendeesList
                                        .map((val, index) => (
                                            <MenuItem
                                                key={val}
                                                value={val}
                                                className="m-8 mt-0 rounded-lg"
                                            >
                                                {val}
                                            </MenuItem>
                                        ))}
                                </StyledSelect>
                            </div>
                        </Grid>
                        <Grid item md={12} lg={12} className="border-2 border-#B5B6B6 rounded m-16 pb-16 pr-16">
                            <Typography sx={{ padding: '8px', display: 'flex', textAlign: 'left', color: '#000000', font: `normal normal normal 14px/21px Poppins`, fontSize: '1vw', background: '#D9D9D999', borderRadius: '20px', }}>
                                {selectedAttendeesList}
                                <CloseOutlinedIcon sx={{ fontSize: "1.3vw", color: '#000000', marginLeft: 'auto', cursor: 'pointer' }} />
                            </Typography>
                        </Grid>
                    </>
                } */}
            </Grid>
            {/* </FormControl> */}
            {/* </div>
            </Box> */}
            {/* <Box sx={{ flexGrow: 1 }}>
                <div className="flex"> */}
            {/* <FormControl className="flex flex-row flex-nowrap"> */}
            {datesArray.length > 0 && datesArray.map((dates, index) => {
                const { trainingCourse, trainingTopic, instructor } = choosenValues[dates] || {};
                const trainingYear = trainingInformation[selectedYear];
                const training = trainingYear && trainingYear[selectedDateRange];
                console.log(training);
                let topicArray = ["Training Topic"];
                if (training?.[dates]) {
                    const topicValuestoDisplay = trainingTopics.find(item => training[dates].trainingCourse in item);
                    topicArray = topicValuestoDisplay ? topicValuestoDisplay[training[dates].trainingCourse] : [];
                }
                return (
                    <Grid container spacing={2} key={index} className="border-t-1 border-#FFFFFF my-24">
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledTextField type="text" variant="outlined" fullWidth name="trainingDates" value={dates} aria-readonly />
                            </div>
                        </Grid>
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledSelect
                                    className="w-full rounded-8 h-2.5 overflow-hidden"
                                    value={training?.[dates]?.trainingCourse || "Training Course"}
                                    name={`trainingCourse-${index}`}
                                    onChange={(e) => {
                                        setSelectedTrainingCourse(e.target.value);
                                        // setViewTrainingTopic(trainingTopics[e.target.value])
                                        handleTrainingInformation('trainingCourse', e.target.value, dates)
                                        // handleSelectChange(index, 'trainingCourse', e.target.value)
                                        //  handleTrainingCourseChange(e.target.value)
                                    }}
                                    variant="outlined"
                                >
                                    {viewTrainingCourse
                                        .map((val, index) => (
                                            <MenuItem
                                                key={val}
                                                value={val}
                                                className="m-8 mt-0 rounded-lg"
                                            >
                                                {val}
                                            </MenuItem>
                                        ))}
                                </StyledSelect>
                            </div>
                        </Grid>
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledSelect
                                    className="w-full rounded-8 h-2.5 overflow-hidden"
                                    value={training?.[dates]?.trainingTopic || "Training Topic"}
                                    name={`trainingTopic-${index}`}
                                    onChange={(e) => {
                                        // handleSelectChange(index, 'trainingTopic', e.target.value)
                                        handleTrainingInformation('trainingTopic', e.target.value, dates)
                                        // setSelectedTrainingTopic(e.target.value); handleTrainingTopicChange(e.target.value)
                                    }}
                                    variant="outlined"
                                >
                                    {topicArray.map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                                </StyledSelect>
                            </div>
                        </Grid>
                        <Grid item md={6} lg={6}>
                            <div className="mr-16">
                                <StyledSelect
                                    className="w-full rounded-8 h-2.5 overflow-hidden"
                                    value={training?.[dates]?.instructor || 'Instructor'}
                                    name={`instructor-${index}`}
                                    onChange={(e) => {
                                        // handleSelectChange(index, 'instructor', e.target.value)
                                        handleTrainingInformation('instructor', e.target.value, dates)
                                        // setSelectedInstructor(e.target.value); handleInstructorChange(e.target.value)
                                    }}
                                    variant="outlined"
                                >
                                    {viewInstructor
                                        .map((val, index) => (
                                            <MenuItem
                                                key={val}
                                                value={val}
                                                className="m-8 mt-0 rounded-lg"
                                            >
                                                {val}
                                            </MenuItem>
                                        ))}
                                </StyledSelect>
                            </div>
                        </Grid>
                        {selectedTab === "forecast" &&
                            <Grid container className="px-24 py-12">
                                <Grid item md={4} lg={4}>
                                    <h4 className="underline decoration-solid" style={{ color: "#EAAA05" }} onClick={() => handleAddAttendee()}>Add Attendees</h4>
                                </Grid>
                                <Grid item md={2} lg={2}>
                                    <FuseSvgIcon>heroicons-solid:user-plus</FuseSvgIcon>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                )
            }
            )
            }
            {/* </FormControl> */}
            {/* </div>
            </Box> */}
            <Grid container>
                <Grid item xs={12} md={12} lg={12} className="flex justify-end m-16">
                    <Button color="warning" className="text-white rounded" variant="contained" onClick={() => { onSaveDraft() }}>Save as Draft</Button>
                </Grid>
            </Grid>
            <div>
                <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleClose}>
                    <Alert ref={alertRef} severity="success" onClose={handleClose}> Event is successfully saved in drafts. </Alert>
                </Snackbar>
            </div>
            <div>
                {showAttendeeList &&
                    <AddAttendees showAddAttendeeList={showAttendeeList} handleClose={handleCloseAttendee}/>
                }
            </div>
        </>
    )
}

export default AddTrainingForm;